import "./RedHeading.css";

const RedHeading = ({ title, subtitle, className = "" }) => {
  return (
    <div className="container container-sec">
      <div className={`RedHeading-title ${className}`}>
        {title && <h2 className="title">{title}</h2>}
        {subtitle && <p className="subtitle">{subtitle}</p>}
      </div>
    </div>
  );
};

export default RedHeading;
